import { AppContextFromSearch, UserInfoType } from '@contexts/app/AppContextFromSearch';
import { getSearch, Search } from '@utils/getSearch';
import { ULPath } from '@ul/common';

const getIframeSize = (search: Search) => {
    const sizeString = search['size'];
    if (!sizeString) {
        return;
    }

    const [width, height] = sizeString.split('x');
    return {
        width: parseInt(width, 10),
        height: parseInt(height, 10),
    };
};

export const getAppContextFromSearch = (): AppContextFromSearch => {
    const search = getSearch();
    const appId = search['appId'] || 'mock-appId';
    const appVersion = search['appVersion'] || 'mock-appVersion';

    const appContextFromSearch: AppContextFromSearch = {
        appId,
        appVersion,
        rpcId: search['rpcId'] || appId,
        initialPath: search['initialPath'] as ULPath,
        iframeSize: getIframeSize(search),
        debugMode: search['debug'] === 'true',
        fullScreen: search['fullScreen'] === 'true',
        useExternalRoute: search['useExternalRoute'] === 'true',
        useExternalNotification: search['useExternalNotification'] === 'true',
        userInfo: {
            username: search['initialUsername'],
            type: search['initialAuthType'] as UserInfoType,
        },
        partnerCenterConfig: {
            signUpType: search['partnerCenterSignUpType'],
        },
        token: search['token'],
        keepMeSignIn: search['keepMeSignIn'] === 'true',
        passkeySupported: search['passkeySupported'] === 'true',
    };
    return appContextFromSearch;
};
